'use strict';

import { DOM } from '../helpers/DOM.js';

export default class Slider2 {
	constructor() {
		if (DOM.el('.levcharity_slider2')) {
			this.#addEvents();
			this.update();
		}
	}

	#addEvents() {
		DOM.addEvent('LevCharityUpdateSlider2', () => {
			this.update();
		});
	}

	async update() {
		const { Swiper } = await import('swiper/bundle');

		document.querySelectorAll('.levcharity_slider2').forEach((el) => {
			if (el.swiper) return;

			const type = (el.dataset.type || 'slider').toLowerCase();
			const slidesPerViewDesktop = +(el.dataset.slidesToShow || 1);
			const slidesPerGroup = +(el.dataset.slidesPerGroup || 1);
			const loop = (el.dataset.infinite || 'false') === 'true';
			const autoplay = (el.dataset.autoplay || 'false') === 'true';
			const autoplayDelay = +(el.dataset.autoplayDelay ?? 3000);

			let slidesPerView = 1;
			const breakpoints = {};

			const multiple = (el.dataset.multiple || 'false') === 'true';
			const customSpaceBetween = el.dataset.spaceBetween !== undefined
				? Math.max(0, +(el.dataset.spaceBetween))
				: null;
			const defaultDesktopSpace = slidesPerViewDesktop >= 6 ? 50 : 20;
			const desktopSpaceBetween = customSpaceBetween !== null ? customSpaceBetween : defaultDesktopSpace;

			if (multiple) {
				slidesPerView = Math.max(1, slidesPerViewDesktop);
			} else {
				slidesPerView = 1;
			}

			const totalSlides = el.querySelectorAll('.levcharity_slider2_slide').length;
			const shouldLoop = loop && totalSlides > slidesPerView;

			const config = {
				direction: 'horizontal',
				loop: shouldLoop,
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 0,
				allowTouchMove: true,
				touchEventsTarget: 'container',
				observer: true,
				observeParents: true,
				pagination: {
					el: el.querySelector('.levcharity_slider2_dots'),
					clickable: true,
				},
				navigation: {
					nextEl: el.querySelector('.levcharity_slider2_next_button'),
					prevEl: el.querySelector('.levcharity_slider2_prev_button'),
				},
				breakpoints: multiple
					? {
						0: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0 },
						768: { slidesPerView, slidesPerGroup, spaceBetween: desktopSpaceBetween },
					}
					: undefined,
			};

			if (autoplay) {
				config.autoplay = { delay: autoplayDelay, disableOnInteraction: false };
			}

			if (multiple && totalSlides <= slidesPerView) {
				el.classList.add('levcharity_slider2--no-scroll');
				if (window.innerWidth >= 768) {
					config.allowTouchMove = false;
					const wrapper = el.querySelector('.levcharity_slider2_slides_wrapper');
					if (wrapper) wrapper.style.justifyContent = 'center';
				}
			}

			new Swiper(el, config);
		});
	}
}
